(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["container-with-tabs-exa"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('tab-bar-exa')) return;
    customElements.define(
      'tab-bar-exa',
      class extends HTMLElement {
        connectedCallback() {
          this._sync = this._sync.bind(this);
          this._handleChange = this._handleChange.bind(this);
          this._handleFocusIn = this._handleFocusIn.bind(this);
          this._handleFocusOut = this._handleFocusOut.bind(this);
          this._underlineFrame = null;
          this._panelAnimations = [];
          this._transitionPanels = null;
          this._activeIndex = 0;

          if (this.classList.contains('container-with-tabs-exa--style-underline') && 'ResizeObserver' in window) {
            var element = this;
            this._underlineResizeObserver = new ResizeObserver(function () {
              element._queueUnderlineSync();
            });
          }

          // Labels are rendered server-side in Liquid; this only fills any that
          // came back blank. Run once now, then keep them in sync if a tab block
          // re-renders or its label changes (e.g. editing in the theme editor).
          this._sync();
          this._observer = new MutationObserver(this._sync);
          this._observer.observe(this, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['data-tab-label']
          });

          this.addEventListener('change', this._handleChange);
          this.addEventListener('focusin', this._handleFocusIn);
          this.addEventListener('focusout', this._handleFocusOut);
        }

        disconnectedCallback() {
          if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
          }
          if (this._underlineResizeObserver) {
            this._underlineResizeObserver.disconnect();
            this._underlineResizeObserver = null;
          }
          if (this._underlineFrame) {
            cancelAnimationFrame(this._underlineFrame);
            this._underlineFrame = null;
          }
          this._finishPanelTransition();
          this.removeEventListener('change', this._handleChange);
          this.removeEventListener('focusin', this._handleFocusIn);
          this.removeEventListener('focusout', this._handleFocusOut);
        }

        _sync() {
          // Scope strictly to THIS container's own nav + panels so a nested
          // "Container with tabs" inside a slide can't shift the index mapping.
          var card = this.querySelector(':scope > .container-with-tabs-exa__card');
          if (!card) return;
          var panels = card.querySelectorAll(
            ':scope > .container-with-tabs-exa__panels > .container-with-tabs-exa__panel, :scope > .container-with-tabs-exa__body > .container-with-tabs-exa__panels > .container-with-tabs-exa__panel'
          );
          var navs = card.querySelectorAll(
            ':scope > .container-with-tabs-exa__nav, :scope > .container-with-tabs-exa__body > .container-with-tabs-exa__nav'
          );
          navs.forEach(function (nav) {
            var tabs = nav.querySelectorAll('.container-with-tabs-exa__tab');
            panels.forEach(function (panel, i) {
              var tab = tabs[i];
              if (!tab) return;
              // First [data-tab-label] in the panel is this tab's own slides
              // root (nested ones sit deeper, so they come later in the tree).
              // Using a descendant search tolerates any wrapper the platform
              // may add around the rendered child block.
              var src = panel.querySelector('[data-tab-label]');
              var label = src && src.getAttribute('data-tab-label');
              // Only fill in a real label that differs - never overwrite a
              // correct server-rendered label with a blank value.
              if (label && tab.textContent.trim() !== label) {
                tab.textContent = label;
              }
            });
          });
          this._observeUnderline(navs);
          this._syncState(card, panels, navs);
        }

        _syncState(card, panels, navs) {
          card = card || this.querySelector(':scope > .container-with-tabs-exa__card');
          if (!card) return;
          panels = panels || card.querySelectorAll(
            ':scope > .container-with-tabs-exa__panels > .container-with-tabs-exa__panel, :scope > .container-with-tabs-exa__body > .container-with-tabs-exa__panels > .container-with-tabs-exa__panel'
          );
          navs = navs || card.querySelectorAll(
            ':scope > .container-with-tabs-exa__nav, :scope > .container-with-tabs-exa__body > .container-with-tabs-exa__nav'
          );
          var inputs = card.querySelectorAll(':scope > .container-with-tabs-exa__input');

          inputs.forEach(function (input, i) {
            panels[i]?.classList.toggle('container-with-tabs-exa__panel--active', input.checked);
            if (panels[i]) {
              panels[i].toggleAttribute('inert', !input.checked);
              panels[i].setAttribute('aria-hidden', input.checked ? 'false' : 'true');
            }
            navs.forEach(function (nav) {
              nav.querySelectorAll('.container-with-tabs-exa__tab')[i]?.classList.toggle('container-with-tabs-exa__tab--active', input.checked);
            });
          });

          var activeIndex = Array.from(inputs).findIndex(function (input) {
            return input.checked;
          });
          if (activeIndex >= 0 && !this._transitionPanels) this._activeIndex = activeIndex;

          this._queueUnderlineSync(navs);
        }

        _observeUnderline(navs) {
          if (!this._underlineResizeObserver) return;

          this._underlineResizeObserver.disconnect();
          navs.forEach((nav) => {
            this._underlineResizeObserver.observe(nav);
            nav.querySelectorAll(':scope > .container-with-tabs-exa__tab').forEach((tab) => {
              this._underlineResizeObserver.observe(tab);
            });
          });
        }

        _queueUnderlineSync(navs) {
          if (!this.classList.contains('container-with-tabs-exa--style-underline')) return;
          if (this._underlineFrame) cancelAnimationFrame(this._underlineFrame);

          var element = this;
          this._underlineFrame = requestAnimationFrame(function () {
            element._underlineFrame = null;
            element._syncUnderline(navs);
          });
        }

        _syncUnderline(navs) {
          var card = this.querySelector(':scope > .container-with-tabs-exa__card');
          if (!card) return;
          navs = navs || card.querySelectorAll(':scope > .container-with-tabs-exa__nav');

          var inputs = Array.from(card.querySelectorAll(':scope > .container-with-tabs-exa__input'));
          var activeIndex = inputs.findIndex(function (input) {
            return input.checked;
          });
          if (activeIndex < 0) return;

          var thickness = parseFloat(getComputedStyle(this).getPropertyValue('--twt-underline-thickness')) || 0;
          navs.forEach(function (nav) {
            var activeTab = nav.querySelectorAll(':scope > .container-with-tabs-exa__tab')[activeIndex];
            if (!activeTab) return;
            if (activeTab.offsetWidth === 0) {
              nav.classList.remove('container-with-tabs-exa__nav--underline-ready');
              return;
            }

            nav.style.setProperty('--twt-underline-x', activeTab.offsetLeft + 'px');
            nav.style.setProperty('--twt-underline-y', activeTab.offsetTop + activeTab.offsetHeight - thickness + 'px');
            nav.style.setProperty('--twt-underline-width', activeTab.offsetWidth + 'px');

            if (!nav.classList.contains('container-with-tabs-exa__nav--underline-ready')) {
              nav.getBoundingClientRect();
              nav.classList.add('container-with-tabs-exa__nav--underline-ready');
            }
          });
        }

        _handleChange(event) {
          if (!event.target.matches('.container-with-tabs-exa__input') || event.target.closest('tab-bar-exa') !== this) return;
          var card = this.querySelector(':scope > .container-with-tabs-exa__card');
          if (!card) return;
          var inputs = Array.from(card.querySelectorAll(':scope > .container-with-tabs-exa__input'));
          var nextIndex = inputs.indexOf(event.target);
          var previousIndex = this._activeIndex;
          var shouldSlide =
            this.dataset.panelTransition === 'slide' &&
            nextIndex >= 0 &&
            previousIndex >= 0 &&
            nextIndex !== previousIndex &&
            typeof Element.prototype.animate === 'function' &&
            !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this._finishPanelTransition();
          if (shouldSlide) {
            shouldSlide = this._slidePanels(previousIndex, nextIndex);
          }
          if (!shouldSlide) {
            this._activeIndex = nextIndex;
            this._syncState();
          }

          // Sliders can't measure while hidden, so nudge them after the newly
          // active panel has laid out.
          requestAnimationFrame(function () {
            window.dispatchEvent(new Event('resize'));
          });
        }

        _slidePanels(previousIndex, nextIndex) {
          var card = this.querySelector(':scope > .container-with-tabs-exa__card');
          if (!card) return false;
          var panelsContainer = card.querySelector(
            ':scope > .container-with-tabs-exa__panels, :scope > .container-with-tabs-exa__body > .container-with-tabs-exa__panels'
          );
          if (!panelsContainer) return false;
          var panels = panelsContainer.querySelectorAll(':scope > .container-with-tabs-exa__panel');
          var previousPanel = panels[previousIndex];
          var nextPanel = panels[nextIndex];
          if (!previousPanel || !nextPanel) return false;

          previousPanel.style.display = 'block';
          nextPanel.style.display = 'block';
          var previousHeight = previousPanel.getBoundingClientRect().height;
          var nextHeight = nextPanel.getBoundingClientRect().height;
          var direction = nextIndex > previousIndex ? 1 : -1;
          var duration = parseInt(this.dataset.panelTransitionDuration, 10);
          if (!Number.isFinite(duration)) duration = 350;
          duration = Math.min(1000, Math.max(100, duration));
          var easing = 'cubic-bezier(0.22, 1, 0.36, 1)';

          panelsContainer.style.height = previousHeight + 'px';
          panelsContainer.style.overflow = 'hidden';
          panelsContainer.style.position = 'relative';
          [previousPanel, nextPanel].forEach(function (panel) {
            panel.style.left = '0';
            panel.style.position = 'absolute';
            panel.style.top = '0';
            panel.style.width = '100%';
          });

          this._transitionPanels = { container: panelsContainer, previous: previousPanel, next: nextPanel };
          this._activeIndex = nextIndex;
          this._syncState();

          var previousAnimation = previousPanel.animate(
            [{ transform: 'translate3d(0, 0, 0)' }, { transform: 'translate3d(' + -100 * direction + '%, 0, 0)' }],
            { duration: duration, easing: easing, fill: 'both' }
          );
          var nextAnimation = nextPanel.animate(
            [{ transform: 'translate3d(' + 100 * direction + '%, 0, 0)' }, { transform: 'translate3d(0, 0, 0)' }],
            { duration: duration, easing: easing, fill: 'both' }
          );
          var heightAnimation = panelsContainer.animate(
            [{ height: previousHeight + 'px' }, { height: nextHeight + 'px' }],
            { duration: duration, easing: easing, fill: 'both' }
          );
          this._panelAnimations = [previousAnimation, nextAnimation, heightAnimation];

          var element = this;
          Promise.all(this._panelAnimations.map(function (animation) {
            return animation.finished.catch(function () {});
          })).then(function () {
            if (element._transitionPanels && element._transitionPanels.next === nextPanel) {
              element._finishPanelTransition();
            }
          });
          return true;
        }

        _finishPanelTransition() {
          (this._panelAnimations || []).forEach(function (animation) {
            animation.cancel();
          });
          this._panelAnimations = [];
          if (!this._transitionPanels) return;

          var transition = this._transitionPanels;
          [transition.previous, transition.next].forEach(function (panel) {
            panel.style.removeProperty('display');
            panel.style.removeProperty('left');
            panel.style.removeProperty('position');
            panel.style.removeProperty('top');
            panel.style.removeProperty('width');
          });
          transition.container.style.removeProperty('height');
          transition.container.style.removeProperty('overflow');
          transition.container.style.removeProperty('position');
          this._transitionPanels = null;
        }

        _handleFocusIn(event) {
          if (!event.target.matches('.container-with-tabs-exa__input') || event.target.closest('tab-bar-exa') !== this) return;
          this._setFocusState(event.target, event.target.matches(':focus-visible'));
        }

        _handleFocusOut(event) {
          if (!event.target.matches('.container-with-tabs-exa__input') || event.target.closest('tab-bar-exa') !== this) return;
          this._setFocusState(event.target, false);
        }

        _setFocusState(input, isVisible) {
          var card = this.querySelector(':scope > .container-with-tabs-exa__card');
          if (!card) return;
          var inputs = Array.from(card.querySelectorAll(':scope > .container-with-tabs-exa__input'));
          var index = inputs.indexOf(input);
          if (index < 0) return;

          card.querySelectorAll(
            ':scope > .container-with-tabs-exa__nav, :scope > .container-with-tabs-exa__body > .container-with-tabs-exa__nav'
          ).forEach(function (nav) {
            nav.querySelectorAll('.container-with-tabs-exa__tab')[index]?.classList.toggle('container-with-tabs-exa__tab--focus-visible', isVisible);
          });
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["expandable-container"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('expandable-container')) {
    customElements.define('expandable-container', class ExpandableContainer extends HTMLElement {
      connectedCallback() {
        this.staticPart = this.querySelector('[data-expandable-static]');
        this.toggleButton = this.querySelector('[data-expandable-toggle]');
        this.panel = this.querySelector('[data-expandable-panel]');
        this.panelInner = this.querySelector('[data-expandable-panel-inner]');
        if (!this.staticPart || !this.panel) return;

        this.panel.id = this.panel.id || `ExpandablePanel-${Math.random().toString(36).slice(2)}`;
        if (this.toggleButton) {
          this.toggleButton.setAttribute('aria-controls', this.panel.id);
        }
        this.staticPart.removeAttribute('aria-controls');
        this.staticPart.removeAttribute('aria-expanded');
        this.staticPart.removeAttribute('role');
        this.staticPart.removeAttribute('tabindex');

        this.handleToggleClick = this.handleToggleClick || this.onToggleClick.bind(this);
        this.handleStaticClick = this.handleStaticClick || this.onStaticClick.bind(this);
        this.handleResize = this.handleResize || this.updatePanelHeight.bind(this);

        if (this.toggleButton) {
          this.toggleButton.removeEventListener('click', this.handleToggleClick);
          this.toggleButton.addEventListener('click', this.handleToggleClick);
        }

        this.staticPart.removeEventListener('click', this.handleStaticClick);
        this.staticPart.addEventListener('click', this.handleStaticClick);

        window.removeEventListener('resize', this.handleResize);
        window.addEventListener('resize', this.handleResize);

        this.setOpen(this.dataset.openByDefault === 'true', false);
      }

      disconnectedCallback() {
        if (this.toggleButton) {
          this.toggleButton.removeEventListener('click', this.handleToggleClick);
        }
        if (this.staticPart) {
          this.staticPart.removeEventListener('click', this.handleStaticClick);
        }
        window.removeEventListener('resize', this.handleResize);
      }

      isInteractiveElement(element) {
        const interactive = element.closest('a, button, input, select, textarea, label, summary, [role="button"], [role="link"], [tabindex]:not([tabindex="-1"])');
        return Boolean(interactive && interactive !== this.staticPart);
      }

      onToggleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setOpen(!this.classList.contains('is-open'), true);
      }

      onStaticClick(event) {
        if (this.staticPart.dataset.clickArea !== 'static_and_button') return;
        if (this.isInteractiveElement(event.target)) return;
        if (event.target.closest('[data-expandable-toggle]')) return;
        this.setOpen(!this.classList.contains('is-open'), true);
      }

      setOpen(open, focusButton) {
        this.classList.toggle('is-open', open);
        if (this.toggleButton) {
          this.toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (focusButton || (!open && this.panel.contains(document.activeElement))) {
            this.toggleButton.focus({ preventScroll: true });
          }
        }
        this.panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        this.panel.toggleAttribute('inert', !open);
        this.updatePanelHeight();
      }

      updatePanelHeight() {
        if (!this.panel) return;
        if (!this.classList.contains('is-open')) {
          this.panel.style.maxHeight = '0px';
          return;
        }
        const target = this.panelInner || this.panel;
        this.panel.style.maxHeight = `${target.scrollHeight}px`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shipping-countdown-exa"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-countdown-exa')) {
    customElements.define(
      'shipping-countdown-exa',
      class ShippingCountdownExa extends HTMLElement {
        connectedCallback() {
          this.timeElement = this.querySelector('[data-shipping-countdown-value]');
          this.statusElement = this.querySelector('[data-shipping-status-value]');
          this.registrationId = null;
          this.dailyInterval = null;
          this.engineReadyHandler = null;
          this.rollingExpired = false;
          this.designMode = this.dataset.designMode === 'true';

          if (this.designMode) this.style.removeProperty('display');

          if (this.dataset.mode === 'daily_cutoff') {
            this.updateDailyCutoff();
            this.dailyInterval = window.setInterval(() => this.updateDailyCutoff(), 1000);
          } else {
            this.startRollingCountdown();
          }
        }

        disconnectedCallback() {
          window.clearInterval(this.dailyInterval);
          window.removeEventListener('load', this.engineReadyHandler);

          if (this.registrationId && window.sessionCountdownEngine) {
            window.sessionCountdownEngine.unregister(this.registrationId);
          }

          this.registrationId = null;
        }

        startRollingCountdown() {
          if (!this.timeElement) return;

          const engine = window.sessionCountdownEngine;
          if (!engine) {
            this.engineReadyHandler = () => {
              if (this.isConnected) this.startRollingCountdown();
            };
            window.addEventListener('load', this.engineReadyHandler, { once: true });
            return;
          }

          const durationMinutes = this.toPositiveNumber(this.dataset.durationMinutes, 10);
          const durationSeconds = this.toSafeDurationSeconds(durationMinutes);
          const countdownKey = this.dataset.countdownKey || `shipping:${durationMinutes}`;

          const registrationId = engine.register(
            countdownKey,
            durationSeconds,
            (remainingSeconds) => this.renderTime(remainingSeconds),
            () => this.expireRollingCountdown()
          );
          this.registrationId = this.rollingExpired ? null : registrationId;

          if (this.statusElement) {
            this.statusElement.textContent = this.dataset.todayText || '';
          }
        }

        expireRollingCountdown() {
          if (this.designMode) {
            const durationMinutes = this.toPositiveNumber(this.dataset.durationMinutes, 10);
            this.registrationId = null;
            this.renderTime(this.toSafeDurationSeconds(durationMinutes));
            this.style.removeProperty('display');
            return;
          }

          this.rollingExpired = true;
          this.registrationId = null;
          this.renderTime(0);
          this.style.display = 'none';
        }

        updateDailyCutoff() {
          if (!this.timeElement) return;

          const now = new Date();
          const target = this.getDailyCutoffTarget(now);
          const remaining = Math.max(0, target.getTime() - now.getTime());
          this.renderTime(Math.floor(remaining / 1000));

          if (this.statusElement) {
            this.statusElement.textContent = this.isAfterDailyCutoff(now) ? this.dataset.afterCutoffText || this.dataset.todayText || '' : this.dataset.todayText || '';
          }
        }

        renderTime(totalSeconds) {
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          const value = `${this.format(hours)}:${this.format(minutes)}:${this.format(seconds)}`;

          this.timeElement.textContent = value;
          this.timeElement.setAttribute('datetime', `PT${hours}H${minutes}M${seconds}S`);
        }

        getDailyCutoffTarget(now) {
          const target = new Date(now);
          target.setHours(this.toNumber(this.dataset.cutoffHour, 23), this.toNumber(this.dataset.cutoffMinute, 59), 0, 0);
          if (target.getTime() <= now.getTime()) target.setDate(target.getDate() + 1);
          return target;
        }

        isAfterDailyCutoff(now) {
          const cutoff = new Date(now);
          cutoff.setHours(this.toNumber(this.dataset.cutoffHour, 23), this.toNumber(this.dataset.cutoffMinute, 59), 0, 0);
          return now.getTime() > cutoff.getTime();
        }

        toNumber(value, fallback) {
          const parsed = Number.parseInt(value, 10);
          return Number.isFinite(parsed) ? parsed : fallback;
        }

        toPositiveNumber(value, fallback) {
          const parsed = Number.parseFloat(value);
          return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
        }

        toSafeDurationSeconds(minutes) {
          const maxSafeSeconds = Math.floor((Number.MAX_SAFE_INTEGER - Date.now()) / 1000);
          return Math.max(1, Math.round(Math.min(minutes, maxSafeSeconds / 60) * 60));
        }

        format(value) {
          return String(value).padStart(2, '0');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vp-slider-exa"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vp-slider-scrub-exa')) {
    customElements.define('vp-slider-scrub-exa', class extends HTMLElement {
      constructor() {
        super();
        this.activePointerId = null;
        this.startX = 0;
        this.startY = 0;
        this.scrubbing = false;
        this.suppressClick = false;
        this.clearSuppressClickTimer = null;
        this.pendingAspectRatioImages = [];
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerEnd = this.onPointerEnd.bind(this);
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('pointermove', this.onPointerMove);
        this.addEventListener('pointerup', this.onPointerEnd);
        this.addEventListener('pointercancel', this.onPointerEnd);
        this.addEventListener('lostpointercapture', this.onPointerEnd);
        this.addEventListener('click', this.onClick, true);
        this.syncImageAspectRatios();
      }

      disconnectedCallback() {
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('pointermove', this.onPointerMove);
        this.removeEventListener('pointerup', this.onPointerEnd);
        this.removeEventListener('pointercancel', this.onPointerEnd);
        this.removeEventListener('lostpointercapture', this.onPointerEnd);
        this.removeEventListener('click', this.onClick, true);
        this.pendingAspectRatioImages.forEach(({ image, onLoad }) => image.removeEventListener('load', onLoad));
        this.pendingAspectRatioImages = [];
        window.clearTimeout(this.clearSuppressClickTimer);
      }

      syncImageAspectRatios() {
        this.querySelectorAll('.color-swatch').forEach((swatch) => {
          const source = swatch.querySelector('[data-swatch-aspect-ratio]');
          const image = swatch.querySelector('.color-swatch__image img');
          const declaredRatio = source ? Number.parseFloat(source.dataset.swatchAspectRatio) : NaN;

          if (Number.isFinite(declaredRatio) && declaredRatio > 0) {
            swatch.style.setProperty('--vps-aspect-ratio', declaredRatio);
            return;
          }
          if (!image) return;

          const applyNaturalRatio = () => {
            if (image.naturalWidth > 0 && image.naturalHeight > 0) {
              swatch.style.setProperty('--vps-aspect-ratio', image.naturalWidth / image.naturalHeight);
            }
          };

          if (image.complete) {
            applyNaturalRatio();
          } else {
            image.addEventListener('load', applyNaturalRatio, { once: true });
            this.pendingAspectRatioImages.push({ image, onLoad: applyNaturalRatio });
          }
        });
      }

      onPointerDown(event) {
        if (!event.isPrimary || this.activePointerId !== null) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.activePointerId = event.pointerId;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.scrubbing = false;
      }

      onPointerMove(event) {
        if (event.pointerId !== this.activePointerId) return;
        const deltaX = Math.abs(event.clientX - this.startX);
        const deltaY = Math.abs(event.clientY - this.startY);

        if (!this.scrubbing) {
          if (deltaY > 10 && deltaY > deltaX) {
            this.resetPointer();
            return;
          }
          if (deltaX < 6 || deltaX < deltaY) return;
          this.scrubbing = true;
          this.suppressClick = true;
          if (this.setPointerCapture) this.setPointerCapture(event.pointerId);
        }

        event.preventDefault();
        this.selectAtPoint(event.clientX, event.clientY);
      }

      onPointerEnd(event) {
        if (event.pointerId !== this.activePointerId) return;
        if (this.scrubbing) this.selectAtPoint(event.clientX, event.clientY);
        this.resetPointer();
        if (this.suppressClick) {
          window.clearTimeout(this.clearSuppressClickTimer);
          this.clearSuppressClickTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 450);
        }
      }

      onClick(event) {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
        window.clearTimeout(this.clearSuppressClickTimer);
      }

      resetPointer() {
        if (this.activePointerId !== null && this.hasPointerCapture && this.hasPointerCapture(this.activePointerId)) {
          this.releasePointerCapture(this.activePointerId);
        }
        this.activePointerId = null;
        this.scrubbing = false;
      }

      selectAtPoint(clientX, clientY) {
        const swatch = this.swatchAtPoint(clientX, clientY);
        if (!swatch) return;
        const input = swatch.querySelector('input[type="radio"]');
        if (!input || input.disabled || input.hidden || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      swatchAtPoint(clientX, clientY) {
        const directTarget = document.elementFromPoint(clientX, clientY);
        const directSwatch = directTarget && directTarget.closest ? directTarget.closest('.color-swatch') : null;
        if (directSwatch && this.contains(directSwatch)) return directSwatch;

        const bounds = this.getBoundingClientRect();
        if (clientX < bounds.left || clientX > bounds.right || clientY < bounds.top || clientY > bounds.bottom) return null;

        let nearest = null;
        let nearestDistance = Infinity;
        this.querySelectorAll('.color-swatch').forEach((swatch) => {
          if (swatch.classList.contains('non-existent')) return;
          const rect = swatch.getBoundingClientRect();
          if (rect.width <= 0 || rect.height <= 0) return;
          const insideY = clientY >= rect.top && clientY <= rect.bottom;
          const centerX = rect.left + rect.width / 2;
          const distance = Math.abs(clientX - centerX) + (insideY ? 0 : Math.min(Math.abs(clientY - rect.top), Math.abs(clientY - rect.bottom)) * 2);
          if (distance < nearestDistance) {
            nearest = swatch;
            nearestDistance = distance;
          }
        });
        return nearest;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
